<template>
  <div>
    <div v-if="!showSave && !timeout">
      <h2>{{ including ? 'Inkluderingsläge aktiverat' : 'Värmer upp...' }}</h2>
      
      <p>För att lägga till en Z-Wave enhet måste du inkludera den i din Bridge. Detta gör du genom att interagera med din fysiska enhet, oftast genom att trycka tre gånger fort på en knapp som finns på enheten.</p>
      
      <p v-if="!including"><i>Vänta medan vi startar igång Z-Wave inkluderingen...</i></p>
  
      <div v-if="including">
        <div style="padding-left:45%;padding-top:1em;" v-if="!done">
          <half-circle-spinner :animation-duration="1000" :size="90" color="#033873" />
        </div>
        <div v-else style="text-align:center;">
          <img src="../assets/check2.gif" width="350">
        </div>

        <div v-if="steps.length" style="margin-top:2em;">
          <table>
            <tbody>
              <tr v-for="step in steps">
                <td width="200">{{ step.time | moment("YYYY-MM-DD HH:mm:ss") }}</td>
                <td>{{ step.string }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-if="showSave && !timeout">
      <h2>Spara din enhet</h2>

      <div class="form">
        <div class="item">
          <div class="label">Namn</div>
          <div><input type="text" v-model="name" placeholder="Namn på enheten"></div>
        </div>

        <div class="item">
          <div class="label">Rum</div>
          <div>
            <select v-model="roomId">
              <option value="0" selected>Välj ett rum (valfritt)</option>
              <option v-for="room in rooms" :value="room.id">{{ room.name }}</option>
            </select>
          </div>
        </div>

        <div class="item">
          <button @click="doSave" :disabled="!ok">{{ saving ? 'Sparar...' : 'Spara enheten' }}</button>
        </div>
      </div>
    </div>
    
    <!-- Vi har fått en timeout -->
    <div v-if="timeout">
      <h2>Åh nej...</h2>
      
      <p>Av någon anledning tog det för lång tid för att dra igång inkluderingsläget, prova att starta om din Bridge och försök sedan igen. Om detta heller inte löser problemet borde du kontakta supporten.</p>
    </div>
    
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { eventbus } from '../eventbus.js';
  import { HalfCircleSpinner } from 'epic-spinners'

export default {
  name: 'include_zwave',
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      including: false,
      steps: [],
      id: 0,
      showSave: false,
      name: '',
      roomId: 0,
      done: false,
      saving: false,
      includeTimeoutTimer: null,
      timeout: false
    }
  },
  methods: {

  },
  created () {
    eventbus.$once('addNodeStarted', () => {
      this.including = true
      
      // Avbryt timern som säger till användaren att det tog för lång tid
      // att dra igång inkluderingsläget
      if (this.includeTimeoutTimer) {
        clearTimeout(this.includeTimeoutTimer)
      }
    })
    
    eventbus.$once('settingAssociations', () => this.addStep('Sätter associationer'))
    eventbus.$on('settingUpSecurity', (json) => {
      if (!json) {
        this.addStep('Sätter upp kryptering...')
      } else {
        const ok = json.secureOK
        
        this.addStep((ok ? 'Krypteringen har satts upp' : 'Lyckades inte sätta upp kryptering'))
      }
    })
    
    eventbus.$once('nodeAdded', () => {
      
      // Hämtar information om den nya noden
      HTTP.get('nodes/' + this.id)
      .then(res => res.data)
      .then(json => {
        
        if ('manufacturerInfo' in json && 'productName' in json.manufacturerInfo) {
          this.addStep(json.manufacturerInfo.productName + ' från ' + json.manufacturerInfo.manufacturerName + ' har inkluderats korrekt')
        } else {
          this.addStep('Enheten har inkluderats korrekt')
        }
        
        setTimeout(() => {
          this.done = true
          this.addStep('Du kommer nu skickas vidare')
        }, 500)
        setTimeout(() => this.showSave = true, 2000)
      })      

    })

    eventbus.$once('addNodeFoundNew', (json) => {
      this.addStep('Hittade en nod som får ID ' + json.id)
      this.id = json.id
    })

    eventbus.$once('settingConfigParams', () => this.addStep('Skickar konfigurationsparametrar'))

    HTTP.post('nodeops/addNodeAbort')
    .then(res => res.data)
    .then(json => {
      const secure = this.$route.query.secure
      
      HTTP.post('nodeops/addNode?secure=' + secure)
      .then(res => res.data)
      .then(json => {
        
        // Starta timern som avgör om det tog för lång tid
        // eller ej.
        this.includeTimeoutTimer = setTimeout(() => this.timeout = true, 30*1000)
      })
    })
    
  },
  
  computed: {
    ok () {
      return this.name.length && !this.saving
    }
  },
  
  methods: {
    rooms () {
      return this.$root.data.rooms
    },

    addStep (string) {
      this.steps.push({
        time: new Date(),
        string: string
      })
    },
    
    doSave () {
      const obj = {
        name: this.name,
        roomId: this.roomId
      }
      
      this.saving = true
      
      // Spara enheten
      HTTP.post('nodes/' + this.id, obj)
      .then(res => res.data)
      .then(json => {
        
        // Hämta den nya noden vi precis lade till
        HTTP.get('nodes/' + this.id)
        .then(res => res.data)
        .then(node => {
          this.$root.data.nodes.push(node)
          
          this.$router.replace({
            name: 'enhet',
            params: {
              id: this.id
            }
          })
        })
      })
    }
  },

  // När vyn försvinner
  destroyed () {
    HTTP.post('nodeops/addNodeAbort')
    eventbus.$off('settingUpSecurity')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/add_enhet_zwave.vue